export default {"src":"/_next/static/image/public/images/flags/flag_975.760a26d247c9640689ed88e1121b43fa.svg","height":16,"width":25};